import React, { useContext } from 'react'
import { ShareContext } from '../../context/ShareContext';
import { Link } from 'react-router-dom';
import '../../styles/User/topbar.css'
import { useNavigate } from 'react-router-dom';

function TopBar() {
  const {isUserLoggedIn, setIsUserLoggedIn, customerDetails, } = useContext(ShareContext)

  const navigate = useNavigate();

  // console.log(customerDetails);

  const logOut = () => {
    // Clear token from local storage
    localStorage.removeItem('accessToken');
  
    // Clear other user-related data from local storage
    localStorage.removeItem('customerDetails');
  
    // Set user logged in state to false
    setIsUserLoggedIn(false);
  
    // Navigate to the login page
    navigate('/reservation/login');
  };

  // console.log(userData);

  return isUserLoggedIn && customerDetails!=null? (
    <div className="top-bar">
        <div className='name-details'>
          <p>Welcome <span>{customerDetails?.firstname + ' ' + customerDetails?.lastname}</span></p>
          <Link to='/user-profile'><button>Change Details</button></Link>
        </div>
      <div className="password-out">
        <button onClick={logOut}>Log Out</button>
      </div>
    </div>
  ) : (
    <div className="top-bar">
      <Link to='/' className='home-link'>Back to Home</Link>
      <div className="right-side">
        <p>You are Welcome!</p>
        <Link to='/reservation/login'><button>Log In</button></Link>
      </div>
    </div>
  );
  
}

export default TopBar